<template>
  <div>
    <label class="text-sm opacity-75">{{ $t('filters.' + filter.title + '.title') }}</label>
    <vue-simple-suggest
      pattern="\w+"
      v-model="model"
      :list="getList"
      :max-suggestions="10"
      :min-length="0"
      :debounce="200"
      :filter-by-query="false"
      :prevent-submit="true"
      :controls="{
        selectionUp: [38, 33],
        selectionDown: [40, 34],
        select: [13, 36],
        hideList: [27, 35]
      }"
      :mode="mode"
      :nullable-select="true"
      ref="suggestComponent"
      placeholder="Search information..."
      :value-attribute="filter.idProperty"
      :display-attribute="filter.labelProperty"
      @select="onSuggestSelect">

      <div class="g">
        <vs-row>
          <vs-col>
            <input type="search" @search="onReset">
          </vs-col>
        </vs-row>
      </div>

      <template slot="misc-item-above" slot-scope="{ suggestions, query }">
      <div class="misc-item" v-if="!loading &&  suggestions.length == 0">
        <span>No results</span>
      </div>
      </template>

      <div slot="suggestion-item" slot-scope="scope" :title="scope.suggestion.description">
        <div class="text">
          <span v-html="boldenSuggestion(scope)"></span>
        </div>
      </div>

      <div class="misc-item" slot="misc-item-below" slot-scope="{ suggestions }" v-if="loading">
        <span>Loading...</span>
      </div>
    </vue-simple-suggest>
  </div>
</template>

<script>
/* eslint-disable security/detect-non-literal-regexp */
import vueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css';

export default {
  name: 'sm-hateoas-filter-select',
  components: {vueSimpleSuggest},
  props: {
    filter: {
      type: Object,
      default () {
        return {
          id: null,
          idProperty: null,
          labelProperty: null,
          multiple: false,
          parameterName: null,
          refreshFilters: false,
          relation: null,
          title: null,
          type: null
        };
      }
    }
  },
  data () {
    return {
      resource: null,
      model: null,
      loading: false,
      mode: 'select'
    };
  },
  watch: {
    filter: {
      immediate: true,
      handler (newValue) {
        newValue.$request().$get('values').then(res => {
          this.resource = res;
        });
      }
    },
    model: {
      immediate: true,
      handler (value) {
        this.$emit('change', value ? value[this.filter.idProperty] : null);
      }
    }
  },
  methods: {
    getList (inputValue) {
      if (!this.resource) return;
      return this.resource.$request().$get('search', {q: inputValue}).then(res => {
        return res.$getEmbedded(this.filter.relation);
      });
    },
    onSuggestSelect (select) {
      this.model = select;
    },
    onReset () {
      this.model = null;
    },
    boldenSuggestion (scope) {
      if (!scope) return scope;
      const {suggestion, query} = scope;
      const result = this.$refs.suggestComponent.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [''];
      return result.replace(new RegExp(`(.*?)(${texts.join('|')})(.*?)`, 'gi'), '$1<b>$2</b>$3');
    }
  }
};
</script>

<style scoped>

</style>
